<template>
  <div class="solution5">
    <div class="banner">
      <div class="w1200">
        <h3>农产品批发市场/交易中心数字化解决方案</h3>
        <p>
          通过数字化对传统批发市场、交易中心、交易所进行升级改造，建立适应现货、电子盘、电商、大宗交易等多种交易的新模式，激活交易中心/交易所，真正发挥市场价值
        </p>
      </div>
    </div>
    <div class="container">
      <img src="~@/assets/mob/images/solution/c_5.jpg" alt="" />
    </div>
    <div class="d_footer">
      <h3>多方位服务批发市场/交易中心</h3>

      <van-grid :border="false" :column-num="2">
        <van-grid-item class="li">
          <div class="img"></div>
          <p>统一化会员管理体系</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>标准化商品管理体系</p>
        </van-grid-item>

        <van-grid-item class="li">
          <div class="img"></div>
          <p>多模式统一交易交收规则</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>统一支付结算</p>
        </van-grid-item>

        <van-grid-item class="li">
          <div class="img"></div>
          <p>标准化物流流通体系</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>全方位多维度风控监管体系</p>
        </van-grid-item>
      </van-grid>

      <div
        class="button"
        @click="
          show = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <Dialog
      :show="show"
      :systemId="systemId"
      title="获取最新解决方案"
      @close="show = false"
    />
  </div>
</template>
<script>
import Dialog from './components/dialog'
export default {
  components: { Dialog: Dialog },
  data() {
    return {
      systemId: '3',
      show: false,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '~@/assets/mob/css/solution.scss';
</style>
